query BusinessUnitCommonData {
  countries(orderBy: COUNTRY_ASC) {
    nodes {
      id
      country
    }
  }
  companyAvailableCurrencies(orderBy: ISO_CODE_ASC) {
    nodes {
      id
      isoCode
      name
    }
  }
}
